import { Icon } from "@mdi/react";

import { mdiLightbulbVariantOutline } from "@mdi/js";
import styled from "styled-components";

interface ForecastUploadInfoProps {
  className?: string;
}

const Wrapper = styled.div`
  display: flex;
  margin-bottom: 16px;
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  flex: 1;
  max-width: 540px;
  padding: 4px 2px;

  border: 1px solid var(--color-qoute-border-color);
  border-radius: var(--border-radius);
  background-color: var(--color-qoute-background);
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
`;

const StyledIcon = styled(Icon)`
  color: var(--color-icon);
`;

const Text = styled.p`
  font-size: 13px;
  font-weight: var(--fontWeightLight);
  margin: 0;
`;

export default function ForecastUploadInfo({ className = "" }: ForecastUploadInfoProps) {
  return (
    <Wrapper className={className}>
      <Container>
        <IconWrapper>
          <StyledIcon path={mdiLightbulbVariantOutline} size={1.5} />
        </IconWrapper>
        <Text>Drag and drop a ValNav or Mosaic Excel decline file to a folder.</Text>
      </Container>
    </Wrapper>
  );
}
